import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'aux-notes-history',
  templateUrl: './notes-history.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotesHistoryComponent {}
